import fullModal from '@/assets/js/fullModal';
import { saveSiteConfig,getBaseSiteConfig } from "@/api/index";
import i18n from '@/i18n/langs'

const state = {
  siteInfo: {},
}

const mutations = {
  SET_SITE_CONFIG_INFO(state, siteInfo) {
    state.siteInfo = siteInfo;
  },
}

const actions = {
  // 設置name
  setSiteConfigInfo: ({ commit }, siteInfo) => {
    commit("SET_SITE_CONFIG_INFO", siteInfo);
  },
  saveSiteConfigInfo: ({ commit }, siteInfo) => {
    return new Promise((resolve, reject) => {
      fullModal.showPreLoader(i18n.t('message.saving'));
      saveSiteConfig(siteInfo).then(res => {
        fullModal.hidePreLoader();
        console.log("site保存成功=", res)
        
        getBaseSiteConfig().then(res=>{
          commit('SET_SITE_CONFIG_INFO', res.data);
        })
        resolve()
      }).catch(error => {
        fullModal.hidePreLoader();
        reject(error)
      })
    })
  },
}

export default {
  state,
  mutations,
  actions,
};
